var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mpay page"
  }, [_c('div', {
    staticClass: "mpay-preload",
    style: {
      background: `
      url(${require('@images/tapcoin/new/mpay-intro.jpg')}),
      `
    }
  }), _c('div', {
    staticClass: "mpay-main"
  }, [_c('div', {
    staticClass: "mpay-banner"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/mpay.jpg`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "mpay-body"
  }, [_c('div', {
    staticClass: "btn-detail"
  }, [_c('div', {
    staticClass: "btn-detail-main",
    on: {
      "click": () => _vm.popMpayDetailShow = true
    }
  }, [_vm._v("Details "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)]), _c('div', {
    staticClass: "mpay-items mpay-app",
    class: _vm.taskError.code > 0 && 'error'
  }, [_vm.showBtnClaimReward ? _c('div', {
    staticClass: "btn-reward",
    on: {
      "click": () => _vm.popMpayTotalRewardInfoShow = true
    }
  }, [_vm._v("Claim Reward")]) : _vm._e(), _c('div', {
    staticClass: "mpay-logo"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/tapcoin/new/mpay-logo.png`),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "mpay-items-price"
  }, [_vm.mpayTaskInfo.taskInfo ? [_vm.mpayTaskInfo.taskInfo.reward ? _c('div', {
    staticClass: "mpay-items-price-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPCOINS-small.png'),
      "alt": ""
    }
  }), _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward)))])]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward && (_vm.mpayTaskInfo.taskInfo.reward || _vm.mpayTaskInfo.taskInfo.reward_token) ? _c('div', {
    staticClass: "mpay-items-price-item"
  }, [_vm._v("+")]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock ? _c('div', {
    staticClass: "mpay-items-price-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
      "alt": ""
    }
  }), _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_stock)))])]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock && _vm.mpayTaskInfo.taskInfo.reward_token ? _c('div', {
    staticClass: "mpay-items-price-item"
  }, [_vm._v("+")]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token ? _c('div', {
    staticClass: "mpay-items-price-item"
  }, [_vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/USDT-small.png'),
      "alt": ""
    }
  }) : _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'TAP' ? _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAP.png'),
      "alt": ""
    }
  }) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(_vm.mpayTaskInfo.taskInfo.reward_token)))] : [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_token)))]], 2) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "mpay-app-btns"
  }, [_vm.mpayTaskInfo.taskInfo ? [!_vm.mpayTaskInfo.taskInfo.completed ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.onClaim
    }
  }, [!_vm.isClaimLoading ? [_vm.firstApplyCard ? [_vm._v("Apply Card")] : [_vm._v("Check")]] : _c('div', {
    staticClass: "circleLoading"
  })], 2) : _c('div', {
    staticClass: "btn claimed"
  }, [_vm._v("Apply Card "), _c('svg-icon', {
    attrs: {
      "name": "icon-ok"
    }
  })], 1)] : _vm._e()], 2), _vm.taskError.code > 0 ? _c('div', {
    staticClass: "mpay-app-error"
  }, [_vm._v(_vm._s(_vm.taskError.message))]) : _vm._e()]), _c('div', {
    staticClass: "mpay-items__title"
  }, [_vm._v(" Earn referral commission "), _vm.firendList && _vm.firendList.length ? _c('span', [_vm._v("(" + _vm._s(_vm.firendList.length) + ")")]) : _vm._e()]), _c('div', {
    staticClass: "mpay-items mpay-invite"
  }, [_c('div', {
    staticClass: "mpay-items-tr"
  }, [_c('div', {
    staticClass: "mpay-items-tr-item"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/icon-people.png'),
      "alt": ""
    }
  }), _vm._v("1")]), _c('div', {
    staticClass: "mpay-items-tr-item dy"
  }, [_vm._v("=")]), _vm.mpayTaskInfo.taskInfo && _vm.mpayTaskInfo.taskInfo.invitation_reward ? _c('div', {
    staticClass: "mpay-items-price"
  }, _vm._l(_vm.mpayTaskInfo.taskInfo.invitation_reward, function (item, index) {
    return _c('div', {
      staticClass: "mpay-items-price-item"
    }, [item.symbol == 'stock' ? _c('img', {
      attrs: {
        "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
        "alt": ""
      }
    }) : item.symbol == 'USDT' ? _c('img', {
      attrs: {
        "src": require('@images/tapcoin/new/USDT-small.png'),
        "alt": ""
      }
    }) : _vm._e(), item.symbol == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(item.value)))] : item.symbol == 'stock' ? [_vm._v(_vm._s(_vm._f("fmt_pre")(item.value)))] : _vm._e(), _vm.mpayTaskInfo.taskInfo.invitation_reward.length - 1 > index ? _c('span', [_vm._v("+")]) : _vm._e()], 2);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "mpay-app-btns invite"
  }, [_c('div', {
    staticClass: "btn btn-invite",
    on: {
      "click": _vm.onInvite
    }
  }, [!_vm.isInviteLoading ? [_vm._v("Invite Now")] : _c('div', {
    staticClass: "circleLoading"
  })], 2)]), _c('div', {
    staticClass: "mpay-invite-history",
    on: {
      "click": _vm.showHistory
    }
  }, [_vm._v("Invitation History "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)])])]), _c('pop-dialog', {
    attrs: {
      "width": "95%",
      "height": "auto",
      "is-loc": "bottom",
      "show": _vm.popMpayInviteShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popMpayInviteShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-mpayinvite"
  }, [_c('div', {
    staticClass: "pop-mpayinvite__title"
  }, [_vm._v(" Invitation History "), _c('div', {
    staticClass: "icon-refresh",
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefresh,
      "name": "icon-refresh"
    }
  })], 1)]), _c('div', {
    staticClass: "pop-mpayinvite-main"
  }, [_c('div', {
    ref: "popMpayinviteRef",
    staticClass: "pop-mpayinvite-list"
  }, [_vm.firendInviteList && _vm.firendInviteList.length > 0 ? _vm._l(_vm.firendInviteList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-mpayinvite-item"
    }, [_c('span', [_c('m-head', {
      attrs: {
        "name": item,
        "bgColor": item.head_color,
        "fontSize": "13",
        "size": "30"
      }
    }), _vm._v(" "), _c('em', [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))])], 1), _c('span', {
      staticClass: "tx"
    }, _vm._l(item.reward, function (itm, index) {
      return _c('i', [itm.symbol == 'stock' ? _c('img', {
        attrs: {
          "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
          "alt": ""
        }
      }) : itm.symbol == 'USDT' ? _c('img', {
        attrs: {
          "src": require('@images/tapcoin/new/USDT-small.png'),
          "alt": ""
        }
      }) : _vm._e(), itm.symbol == 'stock' ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(itm.value)))]) : itm.symbol == 'USDT' ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(itm.value)))]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.invitation_reward.length - 1 > index ? [_vm._v("+")] : _vm._e()], 2);
    }), 0)]);
  }) : [_c('div', {
    staticClass: "pop-mpayinvite-empty"
  }, [_vm._v("No records yet")])]], 2)])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popRewardShow,
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popRewardShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-reward"
  }, [_c('div', {
    staticClass: "pop-reward__title"
  }, [_vm._v("Congratulations!")]), _c('div', {
    staticClass: "pop-reward__sub"
  }, [_vm._v("You’ve received !")]), _c('div', {
    staticClass: "pop-reward-items"
  }, [_vm.mpayRewardTotal['unclaimed'] ? _vm._l(_vm.mpayRewardTotal['unclaimed'].reward, function (item, index) {
    return _c('span', [item.symbol == 'stock' ? _c('img', {
      attrs: {
        "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
        "alt": ""
      }
    }) : item.symbol == 'USDT' ? _c('img', {
      attrs: {
        "src": require('@images/tapcoin/new/USDT-small.png'),
        "alt": ""
      }
    }) : _vm._e(), item.symbol == 'stock' ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(item.total)))]) : item.symbol == 'USDT' ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(item.total)))]) : _vm._e()]);
  }) : _vm._e()], 2), _c('div', {
    staticClass: "pop-reward-btn",
    on: {
      "click": _vm.onPopRewardClose
    }
  }, [_vm._v("Thanks")]), _c('div', {
    staticClass: "pop-reward-balance"
  }, [_c('div', {
    staticClass: "pop-reward-balance__title"
  }, [_vm._v("Balance:")]), _c('div', {
    staticClass: "pop-reward-balance-items"
  }, [_c('i', [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
      "alt": ""
    }
  }), _c('em', [!_vm.isReward ? _c('span', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.userData.stock)))]) : _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.userData.stock),
      "duration": 3
    }
  })], 1)]), _vm.assetsList && _vm.assetsList.length > 0 ? _c('i', {
    attrs: {
      "popMpayTotalRewardInfo__title": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/USDT-small.png'),
      "alt": ""
    }
  }), _c('em', [!_vm.isReward ? _c('span', [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(_vm.assetsList[1].balance)))]) : _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.assetsList[1].balance),
      "duration": 5
    }
  })], 1)]) : _vm._e()])])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popApplyCardRewardShow,
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popApplyCardRewardShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-reward"
  }, [_c('div', {
    staticClass: "pop-reward__title"
  }, [_vm._v("Congratulations!")]), _c('div', {
    staticClass: "pop-reward__sub"
  }, [_vm._v("you have received a reward for successfulhyapplying for the card")]), _c('div', {
    staticClass: "pop-reward-items"
  }, [_vm.mpayTaskInfo.taskInfo ? [_vm.mpayTaskInfo.taskInfo.reward ? _c('span', [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPCOINS-small.png'),
      "alt": ""
    }
  }), _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward)))])]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock ? _c('span', [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
      "alt": ""
    }
  }), _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_stock)))])]) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token ? _c('span', [_vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/USDT-small.png'),
      "alt": ""
    }
  }) : _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'TAP' ? _c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/TAP.png'),
      "alt": ""
    }
  }) : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(_vm.mpayTaskInfo.taskInfo.reward_token)))]) : _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'TAP' ? _c('em', [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_token)))]) : _vm._e()]) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "pop-reward-btn",
    on: {
      "click": () => (_vm.popApplyCardRewardShow = false, _vm.popMpayTotalRewardInfoShow = true)
    }
  }, [_vm._v("Check")])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popMpayDetailShow,
      "width": "80%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popMpayDetailShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popMpayDetail"
  }, [_c('div', {
    staticClass: "popMpayDetail__img"
  }, [_c('img', {
    attrs: {
      "src": require('@images/tapcoin/new/mpay-intro.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "popMpayDetail-info"
  }, [_c('div', {
    staticClass: "popMpayDetail-info-item"
  }, [_c('span', [_vm._v("Apply Your Card: ")]), _vm._v("grab "), _vm.mpayTaskInfo.taskInfo ? _c('i', [_vm.mpayTaskInfo.taskInfo.reward ? [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward)) + " USDT")] : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward && (_vm.mpayTaskInfo.taskInfo.reward || _vm.mpayTaskInfo.taskInfo.reward_token) ? [_vm._v("+")] : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock ? [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_stock)) + " Keys")] : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_stock && _vm.mpayTaskInfo.taskInfo.reward_token ? [_vm._v(" + ")] : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token ? [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.mpayTaskInfo.taskInfo.reward_token)) + " "), _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'USDT' ? [_vm._v("USDT")] : _vm._e(), _vm.mpayTaskInfo.taskInfo.reward_token_symbol == 'TAP' ? [_vm._v("TAP")] : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" instantly! ")]), _c('div', {
    staticClass: "popMpayDetail-info-item"
  }, [_c('span', [_vm._v("Invite: ")]), _vm._v("Invite friends to join and claim "), _vm.mpayTaskInfo.taskInfo ? _vm._l(_vm.mpayTaskInfo.taskInfo.invitation_reward, function (item, index) {
    return _c('i', [_vm._v(" " + _vm._s(_vm._f("fmt_pre")(item.value)) + " "), item.symbol == 'stock' ? [_vm._v("Keys")] : _vm._e(), item.symbol == 'USDT' ? [_vm._v("USDT")] : _vm._e(), _vm.mpayTaskInfo.taskInfo.invitation_reward.length - 1 > index ? [_vm._v(" + ")] : _vm._e()], 2);
  }) : _vm._e(), _vm._v(" each! ")], 2)])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popMpayTotalRewardInfoShow,
      "width": "90%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popMpayTotalRewardInfoShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popMpayTotalRewardInfo"
  }, [_c('div', {
    staticClass: "popMpayTotalRewardInfo__title"
  }, [_vm._v(" Reward "), _c('div', {
    staticClass: "icon-refresh",
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('svg-icon', {
    attrs: {
      "spin": _vm.isRefresh,
      "name": "icon-refresh"
    }
  })], 1)]), _c('div', {
    staticClass: "popMpayTotalRewardInfo-info"
  }, _vm._l(_vm.mpayRewardTotal, function (val, key) {
    return _c('div', {
      staticClass: "popMpayTotalRewardInfo-info-item",
      class: key
    }, [_c('div', {
      staticClass: "popMpayTotalRewardInfo-info-item__title"
    }, [_vm._v(" " + _vm._s(val.title) + " ")]), val.reward ? _c('i', [_vm._l(val.reward, function (item, index) {
      return _c('em', [item.symbol == 'stock' ? _c('img', {
        attrs: {
          "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
          "alt": ""
        }
      }) : item.symbol == 'USDT' ? _c('img', {
        attrs: {
          "src": require('@images/tapcoin/new/USDT-small.png'),
          "alt": ""
        }
      }) : _vm._e(), item.symbol == 'stock' ? [_vm._v(_vm._s(_vm._f("fmt_pre")(item.total)))] : item.symbol == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(item.total)))] : _vm._e(), val.reward.length - 1 > index ? [_vm._v(" + ")] : _vm._e()], 2);
    }), key == 'unclaimed' ? _c('span', {
      on: {
        "click": _vm.getManualClaimReward
      }
    }, [!_vm.isManualClaimLoading ? [_vm._v("Claim")] : _c('div', {
      staticClass: "circleLoading"
    })], 2) : _vm._e()], 2) : _vm._e(), key == 'settlement' ? _c('div', {
      staticClass: "popMpayTotalRewardInfo-info-item__tip"
    }, [_vm._v("Wait for VISA official settlement, usually takes 72 hours")]) : _vm._e()]);
  }), 0), _vm.sortedMpayRewardTotal ? _c('div', {
    staticClass: "popMpayTotalRewardInfo-tabs"
  }, _vm._l(_vm.sortedMpayRewardTotal, function (val, key) {
    return _c('div', {
      staticClass: "popMpayTotalRewardInfo-tabs-item",
      class: val.status == _vm.selectLogsType.status && 'active',
      on: {
        "click": () => _vm.selectLogsType = val
      }
    }, [_vm._v(_vm._s(val.title))]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "popMpayTotalRewardInfo-lists"
  }, [_vm.mpayRewardTotal[_vm.selectLogsType.key].logs.length ? _c('div', {
    staticClass: "popMpayTotalRewardInfo-list"
  }, _vm._l(_vm.mpayRewardTotal[_vm.selectLogsType.key].logs, function (item, index) {
    return _c('div', {
      staticClass: "popMpayTotalRewardInfo-item"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatTime")(item.created_at, "zhy")))]), _c('span', {
      staticClass: "reason"
    }, [_vm._v(_vm._s(item.reason))]), _c('span', _vm._l(item.reward, function (itm, index) {
      return _c('i', [itm.symbol == 'stock' ? _c('img', {
        attrs: {
          "src": require('@images/tapcoin/new/TAPSTOCK-small.png'),
          "alt": ""
        }
      }) : itm.symbol == 'USDT' ? _c('img', {
        attrs: {
          "src": require('@images/tapcoin/new/USDT-small.png'),
          "alt": ""
        }
      }) : _vm._e(), itm.symbol == 'stock' ? [_vm._v(_vm._s(_vm._f("fmt_pre")(itm.value)))] : itm.symbol == 'USDT' ? [_vm._v(_vm._s(_vm._f("fmt_usdtPre")(itm.value)))] : _vm._e(), item.reward.length - 1 > index ? [_vm._v(" + ")] : _vm._e()], 2);
    }), 0)]);
  }), 0) : [_c('div', {
    staticClass: "popMpayTotalRewardInfo-empty"
  }, [_vm._v("No records yet")])]], 2)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };